import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Box,
  Modal,
  IconButton,
  Typography,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { validateDate } from "../../utils/textFieldValidations";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Close,
  OpenInBrowser,
  OpenInBrowserOutlined,
} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import {
  convertDate,
  convertYearMonthDateToMonthDateYear,
} from "../../utils/DateFormats";
import SnackbarComponent from "../../components/SnackBar/snackBar";
const AdminCoupons = () => {
  const [data, setData] = useState([]);
  const [brands, setBrands] = useState([
    {
      id: 3453,
      vendorId: "V1001",
      couponCode: "Vas10",
      name: "Festival",
      startDate: "2023-01-01",
      endDate: "2023-12-31",
      status: "Active",
      minAmount: "200",
    },
    {
      id: 75667,
      vendorId: "V1002",
      couponCode: "Nik18",
      name: "Festival",
      startDate: "2023-01-01",
      endDate: "2023-12-31",
      status: "Active",
      minAmount: "200",
    },
  ]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
   const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [brandNameError, setBrandNameError] = useState("");
  const [selectedCouponId, setSelectedCouponId] = useState(null);
  const [errors, setErrors] = useState({});
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success",
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const [couponForm, setCouponForm] = useState({
    title: "",
    couponcode: "",
    type: "",
    amount: "",
    startDate: "",
    endDate: "",
  });
  const initializeCouponsData = () => {
    setCouponForm({
      title: "",
      couponcode: "",
      type: "",
      amount: "",
      startDate: "",
      endDate: "",
    });
  };

  const [isEditMode, setEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const loginToken = useSelector((state) => state.user.logintoken);
  console.log("token", loginToken);

  useEffect(() => {
    fetchData();
  }, []);

  const {
    data: CouponsData,
    isLoading: isCouponsLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllCoupons"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: createCouponsData,
    isLoading: createCouponsLoading,
    error: createCouponsError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createCoupons"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateCouponsData,
    isLoading: updateCouponsLoading,
    error: updateCouponsError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteCouponsData,
    isLoading: deleteCouponsLoading,
    error: deleteCouponsError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (error) {
    } else if (CouponsData && CouponsData["status"] === true) {
      console.log("CouponsData", CouponsData["data"]);
      setData(CouponsData["data"]);
    }
  }, [CouponsData, error]);

  useEffect(() => {
    if (createCouponsError) {
    } else if (createCouponsData && createCouponsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createCouponsData["message"],
        status: createCouponsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createCouponsData && createCouponsData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createCouponsData["message"],
        status: createCouponsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createCouponsData, createCouponsError]);

  useEffect(() => {
    if (updateCouponsError) {
    } else if (updateCouponsData && updateCouponsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateCouponsData["message"],
        status: updateCouponsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateCouponsData && updateCouponsData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateCouponsData["message"],
        status: updateCouponsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateCouponsData, updateCouponsError]);

  useEffect(() => {
    if (deleteCouponsError) {
    } else if (deleteCouponsData && deleteCouponsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteCouponsData["message"],
        status: deleteCouponsData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteCouponsData && deleteCouponsData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteCouponsData["message"],
        status: deleteCouponsData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteCouponsData, deleteCouponsError]);

  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  // Filter data based on search
  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.coupon_id - a.coupon_id) // Sort by ID in descending order, latest ID first
          .filter(
            (item) =>
              (item.coupon_id &&
                item.coupon_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.coupon_code &&
                item.coupon_code.toLowerCase().includes(search.toLowerCase()))
          )
      : data;

  // Handle open modal for create
  const handleAdd = () => {
    setEditMode(false);
    initializeCouponsData();
    clearErrors();
    setOpen(true);
  };

  const handleMenuOpen = (event, couponId) => {
    setAnchorEl(event.currentTarget);
    setSelectedCouponId(couponId);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleEdit = (couponData) => {
    setEditMode(true);
    setOpen(true);
    setCouponForm({
      ...couponForm,
      title: couponData["title"],
      couponcode: couponData["coupon_code"],
      type: couponData["type"],
      startDate: couponData["start_date"]
        ? convertYearMonthDateToMonthDateYear(couponData["start_date"])
        : null,
      endDate: couponData["end_date"]
        ? convertYearMonthDateToMonthDateYear(couponData["end_date"])
        : null,
      amount: couponData["amount"],
      status:
        couponData["status"] === 1
          ? "Active"
          : couponData["status"] === 0
          ? "Inactive"
          : "",
      couponId: couponData["coupon_id"],
    });
    setAnchorEl(null);
  };

  const handleDelete = (couponId) => {
    const deleteUrl = urls("deleteCoupons", couponId);
    fetchDeleteData(deleteUrl);
  };

  const handleModalClose = () => {
    setOpen(false);
    setModalOpen(false);
    setCouponForm({
      name: "",
      minAmount: "",
      vendorId: "",
      couponCode: "",
      startDate: "",
      endDate: "",
    });
    setEditMode(false);
  };

  const handleImage = (e) => {
    setCouponForm({
      ...couponForm,
      minAmount: URL.createObjectURL(e.target.files[0]),
    });
  };
  const clearErrors = () => {
    setErrors({});
  };
  const handleSubmit = () => {
    let validationErrors = {};
    console.log("couponForm.startDate", couponForm.startDate);
    if (!couponForm["title"] || !couponForm["title"].trim()) {
      validationErrors.title = "Title is required.";
      setErrors(validationErrors);
      return;
    }
    if (!couponForm["couponcode"] || !couponForm["couponcode"].trim()) {
      validationErrors.couponcode = "Coupon code is required.";
      setErrors(validationErrors);
      return;
    }
    if (!couponForm["type"] || !couponForm["type"].trim()) {
      validationErrors.type = "Type is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDate(couponForm.startDate)) {
      validationErrors.startDate = "From date is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDate(couponForm.endDate)) {
      validationErrors.endDate = "To date is required.";
      setErrors(validationErrors);
      return;
    }

    if (!couponForm["amount"] || !couponForm["amount"].trim()) {
      validationErrors.amount = "Amount is required.";
      setErrors(validationErrors);
      return;
    }

    clearErrors();

    const saveBody = {
      title: couponForm["title"],
      coupon_code: couponForm["couponcode"],
      type: couponForm["type"],
      amount: couponForm["amount"],
      start_date: couponForm.startDate
        ? convertDate(couponForm.startDate)
        : null,
      end_date: couponForm.endDate ? convertDate(couponForm.endDate) : null
    };
    if (isEditMode) {
      saveBody.status = couponForm["status"] === "Active" ? 1 : couponForm["status"] === "Inactive" ? 0 : ""
      const updateUrl = urls("updateCoupons", couponForm["couponId"]);
      fetchUpdateData(updateUrl, saveBody);
    } else if(!isEditMode){
      fetchCreateData(saveBody);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();
    if (createCouponsData && createCouponsData["status"] === true) {
      initializeCouponsData();
      setOpen(false);
    }
    if (isEditMode) {
      if (
        updateCouponsData &&
        updateCouponsData["status"] === true
      ) {
        initializeCouponsData();
        setOpen(false);
      }
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };
  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{ width: "30%", backgroundColor: "#FFF", borderRadius: 1 }}
        />
        <Button
          variant="contained"
          color="success"
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Add
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Title</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Coupon Code</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Type</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Valid on</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>End Date</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Order Min Amout</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>STATUS</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>ACTION</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((coupons) => {
                  return (
                    <TableRow key={coupons.coupon_id}>
                      <TableCell>{coupons.coupon_id}</TableCell>
                      <TableCell>{coupons.coupon_code}</TableCell>
                      <TableCell>{coupons.title}</TableCell>
                      <TableCell>{coupons.type}</TableCell>
                      <TableCell>
                        {convertYearMonthDateToMonthDateYear(
                          coupons.start_date
                        )}
                      </TableCell>
                      <TableCell>
                        {convertYearMonthDateToMonthDateYear(coupons.end_date)}
                      </TableCell>
                      <TableCell>{coupons.amount}</TableCell>

                      <TableCell>
                        <Typography
                          color={
                            coupons.status === "Active"
                              ? "green"
                              : coupons.status === "Inactive"
                              ? "red"
                              : "orange"
                          }
                        >
                          {coupons.status == 1
                            ? "Active"
                            : coupons.status == 0
                            ? "Inactive"
                            : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <MoreVertIcon
                          onClick={(e) => handleMenuOpen(e, coupons.coupon_id)}
                        />
                        <Menu
                          anchorEl={anchorEl}
                          open={
                            Boolean(anchorEl) &&
                            selectedCouponId === coupons.coupon_id
                          }
                          onClose={handleMenuClose}
                        >
                          <MenuItem onClick={() => handleEdit(coupons)}>
                            Edit
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDelete(coupons.coupon_id)}
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  );
                })
            )}
          </TableBody>
        </Table>
         <TablePagination
                 rowsPerPageOptions={[5, 10, 15]}
                 component="div"
                 count={data && data.length ? data.length : 0}
                 rowsPerPage={rowsPerPage}
                 page={page}
                 onPageChange={handlePageChange}
                 onRowsPerPageChange={handleRowsPerPageChange}
               />
      </TableContainer>
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      >
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            position: "relative",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={handleModalClose}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" mb={2}>
            {isEditMode ? "Edit Coupon" : "Add Coupon"}
          </Typography>
          <TextField
            name="title"
            label="Title"
            fullWidth
            margin="dense"
            value={couponForm.title}
            onChange={(e) =>
              setCouponForm({
                ...couponForm,
                title: e.target.value,
              })
            }
            error={!!errors.title}
            helperText={
              errors.title && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.title}
                </Typography>
              )
            }
          />
          <TextField
            name="couponCode"
            label="Coupon Code"
            fullWidth
            margin="dense"
            value={couponForm.couponcode}
            onChange={(e) =>
              setCouponForm({
                ...couponForm,
                couponcode: e.target.value,
              })
            }
            error={!!errors.couponcode}
            helperText={
              errors.couponcode && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.couponcode}
                </Typography>
              )
            }
          />
          <TextField
            name="name"
            label="Type"
            fullWidth
            margin="dense"
            value={couponForm.type}
            onChange={(e) =>
              setCouponForm({
                ...couponForm,
                type: e.target.value,
              })
            }
            error={!!errors.type}
            helperText={
              errors.type && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.type}
                </Typography>
              )
            }
          />
          <Box
            sx={{ flex: 1, mt: 1, display: "flex", flexDirection: "column" }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="From Date"
                value={
                  couponForm.startDate ? new Date(couponForm.startDate) : null
                }
                onChange={(newValue) => {
                  setCouponForm({
                    ...couponForm,
                    startDate: newValue,
                  });

                  // Clear error if the date is valid
                  if (newValue) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      startDate: null,
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth sx={{ mb: 4 }} />
                )}
              />
              {errors.startDate && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.startDate}
                </Typography>
              )}
            </LocalizationProvider>
          </Box>

          <Box
            sx={{ flex: 1, mt: 1.5, display: "flex", flexDirection: "column" }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="To Date"
                value={couponForm.endDate ? new Date(couponForm.endDate) : null}
                onChange={(newValue) => {
                  setCouponForm({
                    ...couponForm,
                    endDate: newValue,
                  });

                  // Clear error if the date is valid
                  if (newValue) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      endDate: null,
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth sx={{ mb: 4 }} />
                )}
              />
              {errors.endDate && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.endDate}
                </Typography>
              )}
            </LocalizationProvider>
          </Box>

          <TextField
            sx={{ mt: 1.5 }}
            name="minAmount"
            label="Order Min Amount"
            fullWidth
            margin="dense"
            value={couponForm.amount}
            onChange={(e) =>
              setCouponForm({
                ...couponForm,
                amount: e.target.value,
              })
            }
            error={!!errors.amount}
            helperText={
              errors.amount && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.amount}
                </Typography>
              )
            }
          />

          {isEditMode && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="status-label">Status</InputLabel>
              <Select
                labelId="status-label"
                id="status-select"
                value={couponForm?.status || ""}
                onChange={(e) =>
                  setCouponForm({
                    ...couponForm,
                    status: e.target.value,
                  })
                }
                label="Status"
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          )}

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleModalClose}
            >
              Cancel
            </Button>
            <Button variant="contained" color="success" onClick={handleSubmit}>
              {isEditMode ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminCoupons;
